import Component from './component';

Component.defaultProps = {
    isOrder: false,
};

export default Component;